import { CompanyAppointMentEmpty, CompanyWiseUsers, CompanyChildrenUserDetails, CompanyApptUsers } from "../Components/index.js";

export default [
    {
        path: "/report/company/appointment-empty",
        component: CompanyAppointMentEmpty,
        name: "report.company.appointment.empty",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company/user-expertise",
        component: () => import("../Components/CompanyUserExpertise.vue"),
        name: "report.company.details.expertise",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/company/user-details",
        component: CompanyWiseUsers,
        name: "report.company.details.user",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/company/company-children-user-details",
        component: CompanyChildrenUserDetails,
        name: "report.company.children.details.user",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company/company-appt-users",
        component: CompanyApptUsers,
        name: "report.company.appt.users",
        meta: {
            requiresAuth: true,
        },
    },
];
